import * as Sentry from '@sentry/react';
import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { logger } from '@/util';
import ErrorFallback from './ErrorFallback';

const errorHandler = (error: unknown, _componentStack: string | undefined, eventId: string) => {
  const errorName = error instanceof Error ? error.name : 'unknown';
  logger.debug(`Sentry caught the error: name=${errorName}, eventId=${eventId}`);
};

const resetHandler = () => {};

interface TopLevelBlockingErrorBoundaryProps {
  children: ReactNode;
  sentryEnabled: boolean;
}

/**
 * If sentryEnabled is true, uses the sentry error boundary with our fallback.
 * Otherwise uses one from react-error-boundary.
 */
export default function TopLevelBlockingErrorBoundary({
  children,
  sentryEnabled,
}: TopLevelBlockingErrorBoundaryProps) {
  return sentryEnabled ? (
    <Sentry.ErrorBoundary fallback={ErrorFallback} onReset={resetHandler} onError={errorHandler}>
      {children}
    </Sentry.ErrorBoundary>
  ) : (
    <ErrorBoundary FallbackComponent={ErrorFallback} onReset={resetHandler}>
      {children}
    </ErrorBoundary>
  );
}
